export const jobs = [
  {
    slug: "senior-data-engineer",
    role: "Senior Data Engineer",
    type: "Contract-to-Hire",
    location: "Remote, USA",
    skill: "Data",
    work_authorization: "H-1B Sponsorship",
    summary:
      "Design and build scalable data platforms and pipelines that power analytics and AI for enterprise clients.",
    responsibilities: [
      "Build and maintain reliable ETL/ELT pipelines",
      "Design cloud data platforms and lakehouses",
      "Enable real-time and streaming data use cases",
      "Partner with analytics and ML teams on data readiness",
    ],
    requirements: [
      "5+ years in data engineering",
      "Strong SQL and Python",
      "Experience with a major cloud (AWS/Azure/GCP)",
      "Familiarity with modern data stack tools",
    ],
  },
  {
    slug: "embedded-software-engineer",
    role: "Embedded Software Engineer",
    type: "Contract",
    location: "Austin, TX",
    skill: "Semiconductor",
    work_authorization: "Sponsorship Available",
    summary:
      "Develop firmware and low-level software for semiconductor and electronics products across the full lifecycle.",
    responsibilities: [
      "Develop bare-metal and RTOS firmware",
      "Write and maintain device drivers",
      "Support post-silicon bring-up and validation",
      "Collaborate with hardware and verification teams",
    ],
    requirements: [
      "4+ years in embedded development",
      "Strong C/C++",
      "Experience with microcontrollers and RTOS",
      "Debugging with oscilloscopes/logic analyzers a plus",
    ],
  },
  {
    slug: "cloud-devops-engineer",
    role: "Cloud DevOps Engineer",
    type: "Direct Hire",
    location: "Remote, USA",
    skill: "Cloud",
    work_authorization: "No Sponsorship Required",
    summary:
      "Automate infrastructure and delivery pipelines to help teams ship faster and run reliably at scale.",
    responsibilities: [
      "Build CI/CD pipelines and automation",
      "Manage Kubernetes and container platforms",
      "Implement Infrastructure as Code",
      "Improve observability, cost and reliability",
    ],
    requirements: [
      "4+ years in DevOps/SRE",
      "Kubernetes and Terraform experience",
      "Strong scripting skills",
      "Cloud certification a plus",
    ],
  },
  {
    slug: "machine-learning-engineer",
    role: "Machine Learning Engineer",
    type: "Contract",
    location: "Remote, USA",
    skill: "AI",
    work_authorization: "Open to All Work Authorizations",
    summary:
      "Take machine learning and generative AI systems from prototype to reliable, governed production.",
    responsibilities: [
      "Build ML and generative AI applications",
      "Implement RAG and evaluation harnesses",
      "Deploy models with MLOps best practices",
      "Monitor performance and manage governance",
    ],
    requirements: [
      "4+ years in ML engineering",
      "Strong Python and ML frameworks",
      "Experience deploying models to production",
      "LLM/GenAI experience a plus",
    ],
  },
  {
    slug: "validation-engineer",
    role: "Validation Engineer",
    type: "Contract",
    location: "San Jose, CA",
    skill: "Semiconductor",
    work_authorization: "Green Card",
    summary:
      "Own post-silicon validation and characterization to bring semiconductor products to life.",
    responsibilities: [
      "Plan and execute post-silicon validation",
      "Develop test setups and automation",
      "Characterize and debug silicon issues",
      "Collaborate with design and test teams",
    ],
    requirements: [
      "3+ years in silicon validation",
      "Lab and bench experience",
      "Scripting (Python) for automation",
      "Strong analytical and debugging skills",
    ],
  },
  {
    slug: "full-stack-software-engineer",
    role: "Full-Stack Software Engineer",
    type: "Contract-to-Hire",
    location: "Remote, USA",
    skill: "Engineering",
    work_authorization: "H-1B Transfer",
    summary:
      "Build modern, enterprise-grade applications end to end — from APIs to polished user interfaces.",
    responsibilities: [
      "Develop web applications and APIs",
      "Build microservices and integrations",
      "Contribute to product and UX quality",
      "Write tests and support delivery",
    ],
    requirements: [
      "4+ years full-stack development",
      "React and a backend framework",
      "REST/GraphQL API experience",
      "Cloud deployment familiarity",
    ],
  },
];

export const getJob = (slug) => jobs.find((j) => j.slug === slug);
